<template>
  <div class="product">
    <div class="pro-top">
      <video id="video" autoplay muted loop src="@/assets/product/video/top.mp4" poster="@/assets/product/video/top.png"></video>
      <img class="top-top" src="@/assets/product/top-top2.png" alt="">
    </div>
    <div class="list">
      <div class="item item1" :class="{selected: selected === 0}" @click="select(0)">
        <div class="item-title">
          <div class="">产品</div>
          <div class="subtitle">product</div>
        </div>
        <div class="item-list">
          <div class="i"><div class="r"></div>业主客户端</div>
          <div class="i"><div class="r"></div>业主管理端</div>
          <div class="i"><div class="r"></div>服务商应用端</div>
        </div>
      </div>
      <div class="item item2" :class="{selected: selected === 1}" @click="select(1)">
        <div class="item-title">
          <div class="">iDAS</div>
          <div class="subtitle">iDAS</div>
        </div>
        <div class="item-list">
          <div class="i"><div class="r"></div>数据萃取</div>
          <div class="i"><div class="r"></div>数据分析</div>
          <div class="i"><div class="r"></div>管理赋能</div>
        </div>
      </div>
      <div class="item item3" :class="{selected: selected === 2}" @click="select(2)">
        <div class="item-title">
          <div class="">自主硬件研发</div>
          <div class="subtitle">Independent hardware R & D</div>
        </div>
        <div class="item-list">
          <div class="i"><div class="r"></div>人脸识别</div>
          <div class="i"><div class="r"></div>车牌识别道闸</div>
          <div class="i"><div class="r"></div>二轮充电桩</div>
        </div>
      </div>
    </div>
    <div ref="hash"></div>
    <div class="animate__animated animate__fadeIn" v-show="selected === 0">
      <div class="title">
        <div class="top">产品</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">product</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="products">
        <div class="i" :class="{selected: products === 0}" @click="products = 0">
          <div class="img"><img src="@/assets/product/3-1.png" alt="" v-if="products === 0"><img src="@/assets/product/3-1-1.png" alt="" v-else>APP</div>
          <div class="qr animate__animated animate__fadeIn" v-if="products === 0"><img src="@/assets/product/3-1-2.png" alt=""></div>
        </div>
        <div class="i" :class="{selected: products === 1}" @click="products = 1">
          <div class="img"><img src="@/assets/product/3-2.png" alt="" v-if="products === 1"><img src="@/assets/product/3-2-1.png" alt="" v-else>小程序</div>
          <div class="qr animate__animated animate__fadeIn" v-if="products === 1"><img src="@/assets/product/3-2-2.png" alt=""></div>
        </div>
        <div class="i" :class="{selected: products === 2}" @click="products = 2">
          <div class="img"><img src="@/assets/product/3-3.png" alt="" v-if="products === 2"><img src="@/assets/product/3-3-1.png" alt="" v-else>公众号</div>
          <div class="qr animate__animated animate__fadeIn" v-if="products === 2"><img src="@/assets/product/3-3-2.png" alt=""></div>
        </div>
        <div class="i" :class="{selected: products === 3}" @click="products = 3">
          <div class="img"><img src="@/assets/product/3-4.png" alt="" v-if="products === 3"><img src="@/assets/product/3-4-1.png" alt="" v-else>企业ERP</div>
          <div class="qr animate__animated animate__fadeIn" v-if="products === 3"><img src="@/assets/product/3-4-2.png" alt=""></div>
        </div>
        <div class="i" :class="{selected: products === 4}" @click="products = 4">
          <div class="img"><img src="@/assets/product/3-5.png" alt="" v-if="products === 4"><img src="@/assets/product/3-5-1.png" alt="" v-else>服务商应用</div>
          <div class="qr animate__animated animate__fadeIn" v-if="products === 4"><img src="@/assets/product/3-5-2.png" alt=""></div>
        </div>
      </div>
      <div class="title">
        <div class="top">重点功能</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Key functions</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="functions">
        <div class="i wow animate__fadeInLeft animation-delay-500ms"><img src="@/assets/product/2-1.png" alt=""></div>
        <div class="i wow animate__fadeInLeft animation-delay-300ms"><img src="@/assets/product/2-2.png" alt=""></div>
        <div class="i wow animate__fadeInRight animation-delay-300ms"><img src="@/assets/product/2-3.png" alt=""></div>
        <div class="i wow animate__fadeInRight animation-delay-500ms"><img src="@/assets/product/2-4.png" alt=""></div>
      </div>
      <div class="row">
        <div class="i label">
          <div class="i-title">
            <div>财务公示</div>
            <div class="subtitle">Financial publicity</div>
          </div>
          <div class="e">小区财务全公开，收入全透明。</div>
          <div class="e"><div class="r"></div>账单级别“准确度”的财务公示（秒级更新）；</div>
          <div class="e"><div class="r"></div>让业主清清楚楚看到每笔收支，了解收益边界（公共收益、增值服务）；</div>
          <div class="e"><div class="r"></div>通过财务的公开，可以更好地盘点社区资产，帮助小区更好地运营下去。</div>
        </div>
        <div class="i gif1">
          <div class="img"><img src="@/assets/product/gif/3-1.gif" alt=""></div>
        </div>
      </div>
      <div class="row">
        <div class="i gif2">
          <div class="img"><img src="@/assets/product/gif/3-2.gif" alt=""></div>
        </div>
        <div class="i label">
          <div class="i-title">
            <div>投票决策</div>
            <div class="subtitle">Voting decision</div>
          </div>
          <div class="e">业主参与小区管理，自主选择、推荐、监督、人人参与，打造阳光社区。</div>
          <div class="e"><div class="r"></div>业主可以通过线上发起或参与投票的形式，参与决策，让业主管理权回归；</div>
          <div class="e"><div class="r"></div>可增强业主间的沟通，提高社区温度，可激活整个社区的生态。</div>
        </div>
      </div>
      <div class="row">
        <div class="i label">
          <div class="i-title">
            <div>服务竞标</div>
            <div class="subtitle">Service bidding</div>
          </div>
          <div class="e">业主可投票选出自己满意的专业服务商，参与社区的物业管理事务，来行使业主的权力。</div>
          <div class="e"><div class="r"></div>业主可直接在APP线上投票选择专业服务商，参与社区的物业管理事务；</div>
          <div class="e"><div class="r"></div>公开竞标让社区管理变得更加专业。</div>
        </div>
        <div class="i gif3">
          <div class="img"><img src="@/assets/product/gif/3-3.gif" alt=""></div>
        </div>
      </div>
      <div class="row">
        <div class="i gif4">
          <div class="img"><img src="@/assets/product/gif/3-4.gif" alt=""></div>
        </div>
        <div class="i label">
          <div class="i-title">
            <div>智能门禁</div>
            <div class="subtitle">Intelligent access control</div>
          </div>
          <div class="e">智能门禁系统，是以人脸识别技术为核心，对人的脸部特征信息进行身份认证的识别技术，让我们的居住环境更安全、更智能。</div>
        </div>
      </div>
      <div class="app">
        <div class="img"><img src="@/assets/product/4.png" alt=""></div>
        <div class="text">
          <div>扫码关注【<span>爱多路</span>】微信公众号</div>
          <div>即刻体验</div>
        </div>
      </div>
    </div>
    <div class="animate__animated animate__fadeIn" v-show="selected === 1">
      <div class="title">
        <div class="top">iDAS</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">iDAS</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="subtext">idas围绕小区的业主行为数据，资产数据，财务数据，服务运营数据进行数据萃取，分析，实时监督，为社区智能化管理社区赋能。</div>
      <div class="idas-img"><img src="@/assets/product/idas.png" alt=""></div>
    </div>
    <div class="animate__animated animate__fadeIn" v-show="selected === 2">
      <div class="title">
        <div class="top">自主硬件研发</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Independent hardware R & D</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="row recognition">
        <div class="i label">
          <div class="i-title">
            <div>人脸识别</div>
            <div class="subtitle">Face recognition</div>
          </div>
          <div class="e">是以人脸识别技术为核心，对人的脸部特征信息进行身份认证的生物特征识别技术。因人脸具有不易复制的特性，和传统的门禁卡、指纹相比，更加安全且不易仿制，陌生人无法凭借化妆、戴假发、戴帽子、戴眼镜等方法潜入，在便捷之余具有非常高的安全性！</div>
        </div>
        <div class="i"><img src="@/assets/product/gif/4-1.gif" alt=""></div>
      </div>
      <div class="row recognition">
        <div class="i"><img src="@/assets/product/gif/4-2.gif" alt=""></div>
        <div class="i label">
          <div class="i-title">
            <div>车库可视化</div>
            <div class="subtitle">Garage visualization</div>
          </div>
          <div class="e"><div class="r"></div>快速识别空余车位</div>
          <div class="e"><div class="r"></div>停车场三维建模</div>
          <div class="e"><div class="r"></div>蓝牙定位</div>
          <div class="e"><div class="r"></div>LBS</div>
          <div class="e"><div class="r"></div>地库引导灯</div>
        </div>
      </div>
      <div class="title">
        <div class="top">智能通行管理</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Intelligent traffic management</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="management">
        <img src="@/assets/product/5-1.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
export default {
  name: 'product',
  data () {
    return {
      selected: 0,
      products: 0
    }
  },
  computed: {
    routeSelected () {
      return this.$route.query.selected
    }
  },
  watch: {
    routeSelected (val) {
      if (val !== undefined) {
        const t = this
        t.selected = parseInt(val)
        setTimeout(() => {
          t.$refs.hash.scrollIntoView({
            behavior: 'smooth'
          })
        }, 100)
      }
    }
  },
  mounted () {
    const t = this
    if (t.$route.query.selected !== undefined) {
      t.selected = parseInt(t.$route.query.selected)
      setTimeout(() => {
        t.$refs.hash.scrollIntoView({
          behavior: 'smooth'
        })
      }, 100)
    }
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animate__animated',
      offset: 0,
      mobile: true
    })
    wow.init()
  },
  methods: {
    select (e) {
      this.selected = e
    }
  }
}
</script>
<style scoped>
.product {
  padding-top: 4.3rem;
}
.pro-top {
  position: relative;
}
.top-top {
  position: absolute;
  top: -5rem;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2
}
.title {
  padding: 7.5rem 0;
  background-color: #FFFFFF;
}
.title .top {
  font-size: 2.6rem;
  line-height: 5.4rem;
  font-weight: bolder;
  color: #FF8C33;
}
.title .bottom {
  display: flex;
  align-items: center;
  justify-content: center;
}
.title .line {
  width: 30rem;
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #CECECE;
}
.title .text {
  font-size: 2.6rem;
  font-weight: bolder;
  color: #E7E6E6;
  margin: 0 2rem;
  text-transform: uppercase;
}
.title .text span {
  text-transform: lowercase;
}
.list {
  display: flex;
  align-items: center;
  justify-content: space-around;
  max-width: 150rem;
  margin: 0 auto;
  padding: 10rem 0;
}
.item {
  width: 34.6rem;
  height: 35.2rem;
  padding: 7rem 4rem 0 4rem;
  box-sizing: border-box;
  background-size: 100% 100%;
  border-radius: 1rem;
  box-shadow:0px 0px 2rem 0px rgba(171, 180, 200, 0.3);
  text-align: left;
}
.item .item-title {
  font-size: 2.4rem;
  color: #000000;
  font-weight: bolder;
}
.item .item-title .subtitle {
  font-size: 1.4rem;
  color: #E7E6E6;
  text-transform: uppercase;
}
.item .item-list .i {
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  color: #434343;
  padding-top: 2rem;
}
.r {
  width: 0.8rem;
  min-width: 0.8rem;
  height: 0.8rem;
  background-color: #FF8C33;
  border-radius: 50%;
  margin-right: 1rem;
}
.item1 {
  background-image: url('../assets/product/1-1.png');
}
.item2 {
  background-image: url('../assets/product/1-2.png');
}
.item3 {
  background-image: url('../assets/product/1-3.png');
}
.item.selected {
  border: 0.4rem solid #FEEFDB;
  padding: 6.6rem 3.6rem 0 3.6rem;
}
.item2.selected {
  border-color: #ffebe7;
}
.item3.selected {
  border-color: #e7ecff;
}
.products {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  max-width: 130rem;
  margin: 0 auto;
}
.products .i + .i {
  margin-left: 13rem;
}
.products .i {
  display: flex;
  align-items: center;
  width: 8rem;
  transition: all 0.5s;
  height: 30rem;
}
.products .i .img {
  width: 8rem;
  min-width: 8rem;
}
.products .i .qr {
  width: 20rem;
  margin-left: 2rem;
}
.products .i .img img {
  padding: 0 0 4rem 0;
}
.products .i.selected {
  width: 30rem;
  font-weight: bolder;
  color: #FF8C33;
}
.functions {
  display: flex;
  align-items: center;
  justify-content: space-around;
  max-width: 150rem;
  margin: 0 auto;
  padding: 1rem 0 10rem 0;
}
.functions .i {
  width: 25rem;
}
.row {
  display: flex;
  max-width: 150rem;
  margin: 0 auto;
  padding: 10rem 0;
}
.row.recognition {
  padding: 2rem 0;
}
.row .i {
  width: 50%;
  padding-top: 4rem;
  box-sizing: border-box;
  text-align: left;
}
.gif1 {
  background-color: rgba(255,234,234,0.3);
}
.gif2 {
  background-color: rgba(255,241,230,0.3);
}
.gif3 {
  background-color: rgba(236,237,255,0.3);
}
.gif4 {
  background-color: rgba(246,239,254,0.3);
}
.row .i .img {
  box-sizing: border-box;
  width: 36rem;
  margin: 0 auto;
  padding-right: 7.2rem;
  padding-bottom: 5rem;
  background-image: url('../assets/product/yy.png');
  background-size: 100%;
}
.row .i.label {
  padding-left: 15rem;
}
.row .i .i-title {
  font-size: 2.8rem;
  color: #000000;
  border-left: 0.5rem solid #FF8C33;
  padding-left: 1.5rem;
  font-weight: bolder;
  margin-top: 15rem;
  margin-bottom: 3rem;
}
.row .i .i-title .subtitle {
  font-size: 1.6rem;
  color: #E7E6E6;
  text-transform: uppercase;
}
.row .i .e {
  display: flex;
  font-size: 1.4rem;
  color: #434343;
  width: 50%;
  line-height: 3.6rem;
}
.row .i .e .r {
  margin-top: 1.3rem;
}
.app {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18.3rem;
  background-color: #F9F9F9;
}
.app .img {
  width: 14.8rem;
  margin-right: 4.8rem;
}
.app .text {
  font-size: 3.4rem;
  color: #000000;
  font-weight: bolder;
  line-height: 5rem;
}
.app .text span {
  color: #EE3333;
}
.subtext {
  font-size: 1.4rem;
  color: #434343;
}
.idas-img {
  width: 50%;
  margin: 0 auto;
  padding: 14.5rem;
}
.management {
  max-width: 120rem;
  padding-top: 2rem;
  padding-bottom: 10rem;
  margin: 0 auto;
}
</style>
